import axios from "axios";
import { API_URL } from "../../constants";

export default {
  getAllProduct: (page, pageSize) => {
    console.log("first",page)
    return axios.get(`${API_URL.PRODUCT}/mci`, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
      
      params: {
        page: page,
        pageSize: pageSize,
      },
    });
  },
  getAllProductById: (id) => {
    return axios.get(`${API_URL.PRODUCT}/mci/${id}`, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  productUpload: (data) => {
    return axios.post(API_URL.PRODUCT_FILE, data, {
      headers: { "Content-Type": "multipart/form-data" },
      withCredentials: true,
    });
  },
  createProduct: (data) => {
    return axios.post(`${API_URL.PRODUCT}`, data, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  updateProduct: (id, data) => {
    return axios.patch(`${API_URL.PRODUCT}/${id}`, data, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  getallentity: () => {
    return axios.get(API_URL.GETALL_ENTITY, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  getAllEntityuuid: (id) => {
    return axios.get(`${API_URL.GETALL_ENTITY}/${id}`, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
};
